export const kybStatusEnum = ['APPROVED', 'DENIED', 'IN_PROGRESS', 'NOT_STARTED', 'PROCESSED']

export const kybRiskLevelEnum = ['NOT_DEFINED', 'LOW', 'MEDIUM', 'HIGH', 'VERY_HIGH']

export const kybCreationOriginOptions = [
  {
    label: 'client',
    value: 'none',
  },
  {
    label: 'shareholder',
    value: 'company',
  },
]

export const kybChecksEnum = {
  BR: [
    'SANCTIONS_CNEP',
    'SANCTIONS_CEIS',
    'JUDICIAL_ADMINISTRATIVE_PROCESSES',
    'JUDICIAL_ADMINISTRATIVE_PROCESSES_JUS',
    'GOVERNMENT_DEBTORS',
    'DOMAINS',
    'KYC_BUSINESS',
    // 'NEGATIVE_DEBT_CERTIFICATES',
    'SANCTIONS_CEPIM',
    'SANCTIONS_LENIENCY_AGREEMENTS',
    'NEGATIVE_MEDIA_BUSINESS',
    'SERASA_SCORE',
    'CADE',
    'BLACKLISTS',
    // 'PROTESTOS_BUSINESS',
    'CNJ_JURIDICO',
    'CREDIT_RISK_COMPANY',
    'SINTEGRA',
    'OWNERS_LAWSUITS',
    'COMPROT_COMPANY',
    'FATURAMENTO_PRESUMIDO',
    'AMLDD_ESG',
    'AMLDD_LRI',
    'AMLDD_MTLSN',
    'AMLDD_MTLSN_SIMPLE',
    'AMLDD_MTLSN_WITH_NEWS',
  ],
  CO: [
    'fiscalia-co',
    'judicatura-co',
    'procesos-judiciales-co',
    'bdme-co',
    'simit-co',
    'secop-co',
    'identity-business-co',
  ],
  AR: ['deudores', 'repet', 'sujetosObligados', 'chequesRechazados'],
}

export const shareholderChecksEnum = {
  BR: [
    'SANCTIONS_CNEP',
    'SANCTIONS_CEIS',
    'REGISTRATION_STATUS',
    'KYC_PERSON',
    'SANCTIONS_CEAF',
    'NEGATIVE_MEDIA_PERSON',
    'RELATED_COMPANIES',
    // 'PROTESTOS_PERSON',
    'LAWSUITS_PERSON',
    'JUDICIAL_ADMINISTRATIVE_PROCESSES_JUS',
    'CREDIT_RISK_PERSON',
    'BLACKLISTS_PERSON',
    'SOCIAL_ASSISTANCE',
    'CNJ_FISICO',
    'ANTECEDENTES_PF',
    'COMPROT_PERSON',
    // 'FATURAMENTO_PRESUMIDO',
    'AMLDD_ESG',
    'AMLDD_LRI',
    'AMLDD_PEP',
    'AMLDD_MTLSN',
    'AMLDD_MTLSN_SIMPLE',
    'AMLDD_MTLSN_WITH_NEWS',
  ],
  CO: [
    'fiscalia-co',
    'judicatura-co',
    'procesos-judiciales-co',
    'contraloria-co',
    'procuraduria-co',
    'bdme-co',
    'simit-co',
    'registraduria-co',
    'situacion-militar-co',
    'adres-co',
    'sigep-co',
    'experian-hcpn-co',
    'policia-co',
    'cadaveres-co',
    'inpec-co',
    'desaparecidos-co',
    'rnmc-co',
    'inhabilidades-co',
  ],
  AR: ['deudores', 'repet', 'sujetosObligados', 'chequesRechazados', 'renaper'],
}
